export const styles = {
    canvas: {
        position: 'absolute',
        top: '0px',
        right: '0px',
        width: '100%',
        height: '100vh',
        zIndex: 9990
    },
    gridMessage: {
        zIndex: 9991,
        padding: 25,
        textAlign: 'center',
        color: 'white',
        fontSize: '20px',
        fontWeight: 'bold'
    },
    controlButton: {
        backgroundColor: '#1351B4',
        borderRadius: 10,
        color: 'white',
        height: 40
    }
};